import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { useHistory } from "react-router-dom";
import { isArrayNonEmpty, isValidElement } from '../../util/ApiHelper';
import { deleteRFQDataAction, getChaRFQs, getRequestQuotationList } from '../../appRedux/actions/requestQuotationAction';
import ListEmptyComponent from '../../components/ListEmptyComponent/ListEmptyComponent';
import { Button, Card, Dropdown, Modal, Pagination, Table } from 'antd';
import { CopyOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined, FileTextOutlined, MoreOutlined } from '@ant-design/icons';
import { BUSINESS_TYPE, BUSINESS_TYPE_LABEL, RFQStatus } from '../../util/Constant';
import { formatDate } from '../../util/helper';
import RFQStatusTags from '../requestQuotation/RFQStatus';
import { ItemDetailMobile } from '../../components/ItemDetailMobile';

const getStatus = (data) => {
  return data.totalQuotations > 0 ? RFQStatus.QUOTATION_RECEIVED : data.status;
};
const { Meta } = Card;

const ChaQuotationsList = ({ fromDashboard = false }) => {
  const homePageSize = fromDashboard ? 5 : 10;
     const dispatch = useDispatch();
      const { isMobile } = useGetBreakpoints();
      const history = useHistory();
      const { loading } = useSelector(({ common }) => common);
      const GetChaQuotationsList = useSelector(
        (state) => state.requestQuotations.chaList
      );
      const [showDeleteModel, setShowDeleteModel] = useState(false);
      const [deleteItem, setDeleteItem] = useState(null);
      const [pageSize, setPageSize] = useState(10);
      const description = `You can raise new RFQ’s (Request for Quotation) to get Competitive 
          Quotes from multiple Custom House Agents(CHA).`;
    
            const navigateToDetails = useCallback(
              (id, isClone = false) => {
                if (isValidElement(id)) {
                  if (isClone) {
                    history.push(`rfq-cha/clone/${id}`);
                  } else {
                    history.push(`rfq-cha/view/${id}`);
                  }
                } else {
                  history.push("rfq-cha/details");
                }
              },
              [history]
            );
            const navigateToQuotationsList = useCallback(
              (id) => {
                history.push(`rfq/quotations-list/${id}`);
              },
              [history]
            );

              useEffect(() => {
                dispatch(getChaRFQs({
                  page: 1,
                  limit: pageSize,
                  targetedBusinessType: [BUSINESS_TYPE.CUSTOM_HOUSE_AGENT]
                }));
              }, [dispatch,pageSize]);

               const showDeleteItemModel = useCallback((deleteItem) => {
                  setShowDeleteModel(true);
                  setDeleteItem(deleteItem);
                }, []);
              
                 const handleCancelModel = () => {
                    setShowDeleteModel(false);
                    setDeleteItem(null);
                  };
                  const handleOnREQIconClick = useCallback(() => {
                    dispatch(deleteRFQDataAction(deleteItem));
                    handleCancelModel();
                  }, [deleteItem, dispatch]);
                
                  const moreActionsRenderer = useCallback(
                    (record) => (
                      <div className="myexim-action-icon" onClick={(e) => e.stopPropagation()}>
                        <Dropdown
                          menu={{
                            items: [
                              {
                                label: "View Details",
                                key: "1",
                                icon: <EditOutlined />,
                                onClick: () => {
                                  navigateToDetails(record?.id);
                                },
                              },
                              record?.status !== RFQStatus.DRAFT &&
                                record?.totalQuotations > 0 && {
                                  label: "View Quotations",
                                  key: "2",
                                  icon: <FileTextOutlined />,
                                  onClick: () => {
                                    navigateToQuotationsList(record?.id);
                                  },
                                },
                              record?.status !== RFQStatus.DRAFT &&
                                record?.status !== RFQStatus.PENDING_APPROVAL &&
                                record?.status !== RFQStatus.REJECTED && {
                                  label: "Clone",
                                  key: "3",
                                  icon: <CopyOutlined />,
                                  onClick: () => {
                                    navigateToDetails(record?.id, true);
                                  },
                                },
                              {
                                label: "Delete",
                                key: "4",
                                icon: <DeleteOutlined />,
                                onClick: () => {
                                  showDeleteItemModel(record?.id);
                                },
                              },
                            ],
                          }}
                          trigger={["click"]}
                        >
                          <MoreOutlined />
                        </Dropdown>
                      </div>
                    ),
                    [navigateToDetails, navigateToQuotationsList, showDeleteItemModel]
                  );

                   const columns = useMemo(
                      () => [
                        {
                          title: "Posted Date",
                          key: "createdAt",
                          render: (record) => <div>{formatDate(record?.createdAt)}</div>,
                        },
                        {
                          title: "Product Name",
                          key: "Product Name",
                          render: (record) => <div>{record?.productName}</div>,
                        },
                        {
                          title: " Required Quantity",
                          key: "quantityRequired",
                          width: "150px",
                          render: (record) => (
                            <div>
                              {record?.qty
                                ? `${record.qty} ${record.units || ""}`
                                : `${record.noOfContainers || ""} ${
                                    record.noOfContainers > 1 ? "Containers" : "Container"
                                  }`}
                            </div>
                          ),
                        },
                        {
                          title: "Loading Port",
                          key: "loadingPort",
                          render: (record) => <div>{record?.sourcePort}</div>,
                        },
                        {
                          title: "Destination Port",
                          key: "totalQuotations",
                          render: (record) => <div>{record?.destinationPort}</div>,
                        },
                        {
                          title: "Number of Received Quotations",
                          key: "totalQuotations",
                          render: (record) => <div>{record?.totalQuotations || 0}</div>,
                        },
                        {
                          title: "Status",
                          key: "status",
                          render: (record) => (
                            <div>
                              <RFQStatusTags status={getStatus(record)} />
                            </div>
                          ),
                        },
                        {
                          title: "Actions",
                          key: "actions",
                          render: moreActionsRenderer,
                        },
                      ],
                      [moreActionsRenderer]
                    );
                  
                    const onShowSizeChange = useCallback(
                      (current, pageSize) => {
                        setPageSize(pageSize);
                        dispatch(getChaRFQs({
                          page: current,
                          limit: pageSize,
                          targetedBusinessType: [BUSINESS_TYPE.CUSTOM_HOUSE_AGENT]
                        }));
                      },
                      [dispatch]
                    );
                    const renderContent = useCallback(
                        (data, count) => {
                            return isMobile ? (
                              <>                                  <Card 
                                  // className="mobile-view"
                                  bodyStyle={{ padding: 0 }}
                                  >
                                    {data.map((record) => {
                                      const isfreightForwarder=record.targetedBusinessType ==="freight_forwarder";
                                      const ischa=record.targetedBusinessType ==='custom_house_agent';
                                      const isshippingline=record.targetedBusinessType ==='shipping_line';
                          
                                      let subText = "";
                                      if (isfreightForwarder||isshippingline||ischa) {
                                        subText = `${record.noOfContainers} `;
                                      } else {
                                        subText = `${record.qty} ${record.units}`;
                                      }
                                      console.log("rfqMobile",record.targetedBusinessType !== isfreightForwarder)
                                      return (
                                        <ItemDetailMobile
                                          postedDate={formatDate(record.createdAt)}
                                          primaryRow={{
                                            text: record.productName,
                                            subText:
                                            record.noOfContainers
                                            ? `${record.noOfContainers} Containers`
                                            : `${record.qty} ${record.units}`,
                                                }}
                                          secondaryRow={{
                                            text: BUSINESS_TYPE_LABEL[record?.targetedBusinessType[0]],
                                            subText: `${record?.totalQuotations || 0} quotations recd.`,
                                          }}
                                          status={getStatus(record)}
                                          StatusComponent={RFQStatusTags}
                                          MoreActions={() => moreActionsRenderer(record)}
                                          handleNavigation={() => {
                                            navigateToDetails(record.id);
                                          }}
                                        />
                                      );
                                    })}
                                  </Card>
                                  <Pagination
                                    style={{ marginTop: "16px", textAlign: "right" }}
                                    showSizeChanger
                                    pageSize={pageSize}
                                    total={count}
                                    onChange={onShowSizeChange}
                                    showTotal={(total, range) =>
                                      `${range[0]}-${range[1]} of ${total} items`
                                    }
                                  />
                                </>
                          ) : (
                            <Table
                              rowClassName={(record, index) =>
                                index % 2 === 0 ? "table-row-light" : "table-row-dark"
                              }
                              className="gx-table-responsive rfq-table myexim-table"
                              style={{ marginBottom: fromDashboard ? "40px" : undefined }}
                              columns={columns}
                              dataSource={data}
                              pagination={
                                fromDashboard ?
                                { position: ["none"], pageSize: homePageSize }
                                :{
                                position: ["bottomRight"],
                                showSizeChanger: true,
                                pageSize: pageSize,
                                total: count,
                                onChange: onShowSizeChange,
                                showTotal: (total, range) =>
                                  `${range[0]}-${range[1]} of ${total} items`,
                              }}
                              onRow={(record) => {
                                return {
                                  onClick: (e) => {
                                    if (
                                      !e.target.classList.contains(
                                        "ant-dropdown-menu-title-content"
                                      )
                                    ) {
                                      navigateToDetails(record?.id);
                                    }
                                  },
                                };
                              }}
                            />
                          );
                        },
                        [columns, isMobile, navigateToDetails, onShowSizeChange, pageSize]
                      ); 

  return (
    <>
      <Card
        style={{ width: "100%" }}
        title={
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              {fromDashboard ? (
                <div className="myexim-table-title">{"Find your CHA"}</div>
              ) : (
                <div className="myexim-table-title">{"CHA Details"}</div>
              )}

              {isArrayNonEmpty(GetChaQuotationsList?.rows) && (
                <Button type="primary" onClick={() => navigateToDetails()}>
                   {isMobile ? "+" : "+ Create New RFQ"}
                </Button>
              )}
            </div>
            <div
              style={{
                lineHeight: 1.5,
                fontSize: "14px",
                wordWrap: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              <span style={{ color: "#1677ff" }}>{description}</span>
            </div>
          </div>
        }
      >
        {isArrayNonEmpty(GetChaQuotationsList?.rows)
          ? renderContent(
              GetChaQuotationsList?.rows.filter((record) => {
                if (!Array.isArray(record.targetedBusinessType)) return false;

                const flattenedTypes = record.targetedBusinessType.flat();
                return flattenedTypes.includes(
                  BUSINESS_TYPE.CUSTOM_HOUSE_AGENT
                );
              }),
              GetChaQuotationsList.count
            )
          : !loading && (
              <ListEmptyComponent
                message="No RFQs Created Yet, Try it now"
                buttonText="+ Create New RFQ"
                onButtonClick={() => navigateToDetails()}
              />
            )}
      </Card>
      <Modal
        title="Confirmation"
        open={showDeleteModel}
        onCancel={handleCancelModel}
        centered
        footer={null}
      >
        <div className={"delete-modal-content"}>
          <ExclamationCircleOutlined className={"delete-icon"} size={40} />{" "}
          <p>Do you want to delete this item?</p>
          <Button type="default" onClick={() => handleCancelModel()}>
            Cancel
          </Button>
          <Button type="primary" onClick={() => handleOnREQIconClick()}>
            Ok
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ChaQuotationsList;
